import { Navigate } from 'react-router-dom';

import FEATURES from 'global/features';
import { routePaths } from 'global/routePaths';
import { useFeatureList } from 'store/useFeatureStore';

import TimeOffSetupTabs from './TimeOffSetupTabs';

const TimeOffSetup = () => {
  const featureList = useFeatureList();

  if (!featureList[FEATURES.time_off]) return <Navigate replace to={routePaths.companySettings.general} />;

  return <TimeOffSetupTabs />;
};

export default TimeOffSetup;
